import React from 'react';
import styles from '../styles/portfolio.scss';
import {ProjectBrief} from "./portfolio/ProjectBrief";
import {DistributedCounter} from "./svg/project_icons/DistributedCounter";
import {Auth} from "./svg/project_icons/Auth";
import {DistributedCounterDesc} from "./portfolio/DistributedCounterDesc";
import {AuthServiceDesc} from "./portfolio/AuthServiceDesc";
import {DynamoDB} from "./svg/tech_icons/DynamoDB";
import {IconTextContainer} from "./portfolio/IconTextContainer";
import {FastAPI} from "./svg/tech_icons/FastAPI";
import {Python} from "./svg/tech_icons/Python";
import {Database} from "./svg/tech_icons/Database";
import {ReactIcon} from "./svg/tech_icons/ReactIcon";
import {AwsApiGateway} from "./svg/tech_icons/AwsApiGateway";
import {AwsGeneric} from "./svg/tech_icons/AwsGeneric";
import {Docker} from "./svg/tech_icons/Docker";
import {Webpack} from "./svg/tech_icons/Webpack";
import {Kafka} from "./svg/tech_icons/Kafka";
import {Faust} from "./svg/tech_icons/Faust";
import {RocksDB} from "./svg/tech_icons/RocksDB";
import {Website} from "./svg/project_icons/Website";
import {PersonalWebsite} from "./portfolio/PersonalWebsite";
import {ReactRouterIcon} from "./svg/tech_icons/ReactRouterIcon";
import {Sass} from "./svg/tech_icons/Sass";
import {S3} from "./svg/tech_icons/S3";
import {CloudFront} from "./svg/tech_icons/CloudFront";
import {GithubAction} from "./svg/tech_icons/GithubAction";
import {CertBot} from "./svg/project_icons/CertBot";
import {TLSManager} from "./portfolio/TLSManager";
import {AwsEFS} from "./svg/tech_icons/AwsEFS";
import {useNavigate} from "react-router-dom";


export const Portfolio = props => {
    const navigate = useNavigate();

    function onDistributedCounterDocClick() {
        navigate("/portfolio/distributed-counter");
    }

    function onDistributedCounterCodeClick() {
        navigate("/portfolio/distributed-counter#implementation");
    }

    function onAuthenticationDocClick() {
        navigate("/portfolio/authentication-as-a-service");
    }

    function onAuthenticationCodeClick() {
        navigate("/portfolio/authentication-as-a-service#implementation");
    }

    return (
        <div className={styles.portfolioContainer}>
            <ProjectBrief
                className={styles.projectContainer}
                IconComp={DistributedCounter}
                title={'Distributed Counter'}
                DescriptionCompInstance={<DistributedCounterDesc />}
                iconComponentList={[
                    <IconTextContainer text={'Faust'} IconComp={Faust} key={'dist-counter-faust-icon'}/>,
                    <IconTextContainer text={'Kafka'} IconComp={Kafka} key={'dist-counter-kafka-icon'}/>,
                    <IconTextContainer text={'RocksDB'} IconComp={RocksDB} key={'dist-counter-RocksDB-icon'}/>,
                    <IconTextContainer text={'SocketIO'} IconComp={Python} key={'dist-counter-socketio-icon'}/>,
                    <IconTextContainer text={'DockerCompose'} IconComp={Docker} key={'dist-counter-docker-icon'}/>,
                    <IconTextContainer text={'ReactJS'} IconComp={ReactIcon} key={'personal-react-icon'}/>,
                ]}
                optionComponents={[
                    <IconTextContainer text={'View Docs'} key={'docs-faust'} isOption={true} onClick={onDistributedCounterDocClick}/>,
                    <IconTextContainer text={'Get Code'} key={'code-faust'} isOption={true} onClick={onDistributedCounterCodeClick}/>,
                ]}
            />
            <ProjectBrief
                className={styles.projectContainer}
                IconComp={Auth}
                title={'OAuth2 for Single Page Applications'}
                DescriptionCompInstance={<AuthServiceDesc/>}
                iconComponentList={[
                    <IconTextContainer text={'FastAPI'} IconComp={FastAPI} key={'auth-fastapi-icon'}/>,
                    <IconTextContainer text={'DynamoDB'} IconComp={DynamoDB} key={'auth-ddb-icon'}/>,
                    <IconTextContainer text={'MariaDB'} IconComp={Database} key={'auth-database-icon'}/>,
                    <IconTextContainer text={'ApiGateway'} IconComp={AwsApiGateway} key={'auth-apigateway-icon'}/>,
                    <IconTextContainer text={'Aws Lambda'} IconComp={AwsGeneric} key={'auth-awslambda-icon'}/>,
                    <IconTextContainer text={'DockerCompose'} IconComp={Docker} key={'auth-docker-icon'}/>,
                    <IconTextContainer text={'ReactJS'} IconComp={ReactIcon} key={'auth-react-icon'}/>,
                    <IconTextContainer text={'Webpack'} IconComp={Webpack} key={'auth-webpack-icon'}/>,
                    <IconTextContainer text={'SQL Alchemy'} IconComp={Python} key={'auth-sqlalchemy-icon'}/>,
                    <IconTextContainer text={'Dependency Injector'} IconComp={Python} key={'auth-di-icon'}/>,
                    <IconTextContainer text={'Pytest'} IconComp={Python} key={'auth-pytest-icon'}/>,
                ]}
                optionComponents={[
                    <IconTextContainer text={'View Docs'} key={'docs-auth'} isOption={true} onClick={onAuthenticationDocClick}/>,
                    <IconTextContainer text={'Get Code'} key={'code-auth'} isOption={true} onClick={onAuthenticationCodeClick}/>,
                ]}
            />
                <ProjectBrief
                    className={styles.projectContainer}
                    IconComp={Website}
                    title={'How to create & deploy this website'}
                    DescriptionCompInstance={<PersonalWebsite/>}
                    iconComponentList={[
                            <IconTextContainer text={'ReactJS'} IconComp={ReactIcon} key={'personal-react-icon'}/>,
                            <IconTextContainer text={'Webpack'} IconComp={Webpack} key={'personal-webpack-icon'}/>,
                            <IconTextContainer text={'SASS'} IconComp={Sass} key={'personal-sass-icon'}/>,
                            <IconTextContainer text={'ReactRouter'} IconComp={ReactRouterIcon} key={'personal-reactrouter-icon'}/>,
                            <IconTextContainer text={'AWS S3'} IconComp={S3} key={'personal-s3-icon'}/>,
                            <IconTextContainer text={'AWS Cloudfront Distribution'} IconComp={CloudFront} key={'personal-cloudfront-icon'}/>,
                            <IconTextContainer text={'Github Actions'} IconComp={GithubAction} key={'personal-gitactions-icon'}/>,
                    ]}
                    optionComponents={[
                        <IconTextContainer text={'View Docs'} key={'docs-personal'} isOption={true} disabled={true}/>,
                        <IconTextContainer text={'Get Code'} key={'code-personal'} isOption={true} disabled={true}/>,
                    ]}
                />
                <ProjectBrief
                    className={styles.projectContainer}
                    IconComp={CertBot}
                    title={'TLS Certificates lifecycle manager with AWL Lambda'}
                    DescriptionCompInstance={<TLSManager/>}
                    iconComponentList={[
                        <IconTextContainer text={'Aws Lambda'} IconComp={AwsGeneric} key={'certbot-awslambda-icon'}/>,
                        <IconTextContainer text={'Aws EFS'} IconComp={AwsEFS} key={'certbot-efs-icon'}/>,
                        <IconTextContainer text={'Certbot'} IconComp={CertBot} key={'certbot-bot-icon'}/>,
                    ]}
                    optionComponents={[
                        <IconTextContainer text={'View Docs'} key={'docs-certbot'} isOption={true} disabled={true}/>,
                        <IconTextContainer text={'Get Code'} key={'code-certbot'} isOption={true} disabled={true}/>,
                    ]}
                />
        </div>
    )
}
